<div class="app-header app-container">
    <div class="headerTab container-fluid">
        <div class="d-flex align-items-center py-3 justify-content-between g-10">
            <div class="d-flex align-items-center d-lg-none ms-n2 me-2" title="Show sidebar menu"
                (click)="onHideShow()">
                <div class="d-flex align-items-center justify-content-center">
                    <i class="fa fa-solid fa-bars fs-4"></i>
                </div>
            </div>
            <!-- </div> -->
            <div class="d-flex align-items-center cursorPointer" (click)="goToHomePage()">
                <img src="images/logo.png" class='h-70px app-sidebar-logo-default logo-bg' />
            </div>
            <div class="d-flex align-items-center">
            </div>
            <div class="d-flex align-items-center">
                <div class="cursorPointer app-navbar-item ms-md-3" (click)="dashboard()">
                    <div class="d-flex align-items-center justify-content-center cursor-pointer">
                        <i class="fa-solid fa-user fs-4 text-white"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>